export default __webpack_public_path__ + "static/media/logo-oasis.451cdaa9.svg";